module.exports = __webpack_public_path__ + "img/20200416141854TIM截图20200416140817.8cc7e8a1.png";